import React from 'react'
import PropTypes from 'prop-types'
import { Logo } from './Logo'

export function DfinityLogo({ width = 250 }) {
  const ratio = width / 260
  const logoWidth = Math.floor(ratio * 104)
  const wordWidth = Math.floor(ratio * 144)
  const gapWidth = Math.floor(ratio * 12)

  return (
    <span className="dfinity-logo-wordmark">
      <Logo width={logoWidth} style={{ marginRight: `${gapWidth}px` }} />
      <svg
        width={wordWidth}
        viewBox="0 0 144 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.44301 0.93457H1.75647C1.14204 0.93457 0.738281 1.3403 0.738281 1.95772V14.0239C0.738281 14.6413 1.14204 15.047 1.75647 15.047H5.44301C9.67375 15.047 12.6405 12.154 12.6405 7.9908C12.6405 3.84526 9.67375 0.93457 5.44301 0.93457ZM9.93707 7.9908C9.93707 10.778 8.07624 12.7185 5.42545 12.7185H3.44174V3.26312H5.42545C8.07624 3.26312 9.93707 5.20359 9.93707 7.9908Z"
          fill="white"
        />
        <path
          d="M33.0566 0.93457H25.859C25.2446 0.93457 24.8408 1.3403 24.8408 1.95772V14.0239C24.8408 14.6413 25.2446 15.047 25.859 15.047H26.5086C27.123 15.047 27.5267 14.6413 27.5267 14.0239V9.27856H32.214C32.8284 9.27856 33.2497 8.85518 33.2497 8.23776V7.9908C33.2497 7.37338 32.8459 6.96764 32.214 6.96764H27.5267V3.26312H33.0566C33.671 3.26312 34.0748 2.85739 34.0748 2.23997V1.95772C34.0572 1.3403 33.671 0.93457 33.0566 0.93457Z"
          fill="white"
        />
        <path
          d="M50.0349 0.93457H49.3854C48.7709 0.93457 48.3672 1.3403 48.3672 1.95772V14.0239C48.3672 14.6413 48.7709 15.047 49.3854 15.047H50.0349C50.6493 15.047 51.0531 14.6413 51.0531 14.0239V1.95772C51.0531 1.3403 50.6493 0.93457 50.0349 0.93457Z"
          fill="white"
        />
        <path
          d="M75.7163 0.93457H75.0668C74.4524 0.93457 74.0486 1.3403 74.0486 1.95772V10.0018L67.7815 1.49907C67.5006 1.12862 67.1495 0.952212 66.658 0.952212H66.3771C65.7627 0.952212 65.3589 1.35794 65.3589 1.97536V14.0415C65.3589 14.6589 65.7627 15.0647 66.3771 15.0647H67.0266C67.641 15.0647 68.0448 14.6589 68.0448 14.0415V5.96213L74.3295 14.5178C74.6103 14.8883 74.9614 15.0647 75.453 15.0647H75.7163C76.3483 15.0647 76.7521 14.6589 76.7521 14.0415V1.97536C76.7521 1.3403 76.3483 0.93457 75.7163 0.93457Z"
          fill="white"
        />
        <path
          d="M92.7107 0.93457H92.0611C91.4467 0.93457 91.043 1.3403 91.043 1.95772V14.0239C91.043 14.6413 91.4467 15.047 92.0611 15.047H92.7107C93.3251 15.047 93.7289 14.6413 93.7289 14.0239V1.95772C93.7289 1.3403 93.3251 0.93457 92.7107 0.93457Z"
          fill="white"
        />
        <path
          d="M118.534 0.93457H109.054C108.439 0.93457 108.036 1.3403 108.036 1.95772V2.23997C108.036 2.85739 108.439 3.26312 109.054 3.26312H112.46V14.0239C112.46 14.6413 112.863 15.047 113.478 15.047H114.11C114.724 15.047 115.128 14.6413 115.128 14.0239V3.26312H118.534C119.148 3.26312 119.552 2.85739 119.552 2.23997V1.95772C119.534 1.3403 119.148 0.93457 118.534 0.93457Z"
          fill="white"
        />
        <path
          d="M143.917 1.35794C143.776 1.09333 143.478 0.93457 143.074 0.93457H142.249C141.74 0.93457 141.371 1.14626 141.143 1.55199L137.843 6.84416L134.578 1.56963C134.349 1.14626 133.981 0.93457 133.472 0.93457H132.629C132.243 0.93457 131.927 1.09333 131.786 1.35794C131.699 1.51671 131.611 1.85188 131.909 2.29289L136.509 9.27856V14.0239C136.509 14.6413 136.912 15.047 137.527 15.047H138.159C138.791 15.047 139.195 14.6413 139.195 14.0239V9.27856L143.776 2.29289C144.092 1.83424 144.005 1.51671 143.917 1.35794Z"
          fill="white"
        />
      </svg>
    </span>
  )
}

DfinityLogo.propTypes = {
  width: PropTypes.number,
}
